/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanySector
 */
export interface CompanySector {
    /**
     * 
     * @type {string}
     * @memberof CompanySector
     */
    sector?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanySector
     */
    industries?: Array<string>;
}

/**
 * Check if a given object implements the CompanySector interface.
 */
export function instanceOfCompanySector(value: object): value is CompanySector {
    return true;
}

export function CompanySectorFromJSON(json: any): CompanySector {
    return CompanySectorFromJSONTyped(json, false);
}

export function CompanySectorFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanySector {
    if (json == null) {
        return json;
    }
    return {
        
        'sector': json['sector'] == null ? undefined : json['sector'],
        'industries': json['industries'] == null ? undefined : json['industries'],
    };
}

export function CompanySectorToJSON(value?: CompanySector | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'sector': value['sector'],
        'industries': value['industries'],
    };
}

